<template>
  <div class="testimonial__stars flex gap-1 text-christine">
    <template v-for="count in 5" :key="count">
      <svg
        v-if="stars - count + 1 >= 1"
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
      >
        <path
          d="M9.40401 1.49833C9.74775 0.681871 10.9185 0.681872 11.2623 1.49833L13.291 6.31722C13.436 6.66142 13.7637 6.8966 14.1398 6.92639L19.4058 7.34346C20.298 7.41413 20.6598 8.51412 19.98 9.08939L15.9679 12.4847C15.6814 12.7272 15.5561 13.1078 15.6437 13.4703L16.8695 18.547C17.0771 19.4071 16.13 20.087 15.3661 19.6261L10.8577 16.9055C10.5356 16.7112 10.1306 16.7112 9.80861 16.9055L5.30012 19.6261C4.53624 20.087 3.58909 19.4071 3.79676 18.547L5.02255 13.4703C5.11011 13.1078 4.98495 12.7272 4.69839 12.4847L0.686192 9.08939C0.00641212 8.51412 0.368198 7.41413 1.26042 7.34346L6.52648 6.92639C6.90263 6.8966 7.23029 6.66142 7.3752 6.31722L9.40401 1.49833Z"
          fill="currentColor"
        />
      </svg>
      <svg
        v-else-if="stars - count + 1 >= 0.5"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <defs>
          <clipPath id="half-star-clip">
            <rect x="0" y="0" width="10.5" height="20" />
          </clipPath>
        </defs>
        <path
          d="M9.40401 1.49833C9.74775 0.681871 10.9185 0.681872 11.2623 1.49833L13.291 6.31722C13.436 6.66142 13.7637 6.8966 14.1398 6.92639L19.4058 7.34346C20.298 7.41413 20.6598 8.51412 19.98 9.08939L15.9679 12.4847C15.6814 12.7272 15.5561 13.1078 15.6437 13.4703L16.8695 18.547C17.0771 19.4071 16.13 20.087 15.3661 19.6261L10.8577 16.9055C10.5356 16.7112 10.1306 16.7112 9.80861 16.9055L5.30012 19.6261C4.53624 20.087 3.58909 19.4071 3.79676 18.547L5.02255 13.4703C5.11011 13.1078 4.98495 12.7272 4.69839 12.4847L0.686192 9.08939C0.00641212 8.51412 0.368198 7.41413 1.26042 7.34346L6.52648 6.92639C6.90263 6.8966 7.23029 6.66142 7.3752 6.31722L9.40401 1.49833Z"
          fill="currentColor"
          clip-path="url(#half-star-clip)"
        />
        <path
          d="M9.40401 1.49833C9.74775 0.681871 10.9185 0.681872 11.2623 1.49833L13.291 6.31722C13.436 6.66142 13.7637 6.8966 14.1398 6.92639L19.4058 7.34346C20.298 7.41413 20.6598 8.51412 19.98 9.08939L15.9679 12.4847C15.6814 12.7272 15.5561 13.1078 15.6437 13.4703L16.8695 18.547C17.0771 19.4071 16.13 20.087 15.3661 19.6261L10.8577 16.9055C10.5356 16.7112 10.1306 16.7112 9.80861 16.9055L5.30012 19.6261C4.53624 20.087 3.58909 19.4071 3.79676 18.547L5.02255 13.4703C5.11011 13.1078 4.98495 12.7272 4.69839 12.4847L0.686192 9.08939C0.00641212 8.51412 0.368198 7.41413 1.26042 7.34346L6.52648 6.92639C6.90263 6.8966 7.23029 6.66142 7.3752 6.31722L9.40401 1.49833Z"
          stroke="currentColor"
          stroke-width="0.75"
        />
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M9.40401 1.49833C9.74775 0.681871 10.9185 0.681872 11.2623 1.49833L13.291 6.31722C13.436 6.66142 13.7637 6.8966 14.1398 6.92639L19.4058 7.34346C20.298 7.41413 20.6598 8.51412 19.98 9.08939L15.9679 12.4847C15.6814 12.7272 15.5561 13.1078 15.6437 13.4703L16.8695 18.547C17.0771 19.4071 16.13 20.087 15.3661 19.6261L10.8577 16.9055C10.5356 16.7112 10.1306 16.7112 9.80861 16.9055L5.30012 19.6261C4.53624 20.087 3.58909 19.4071 3.79676 18.547L5.02255 13.4703C5.11011 13.1078 4.98495 12.7272 4.69839 12.4847L0.686192 9.08939C0.00641212 8.51412 0.368198 7.41413 1.26042 7.34346L6.52648 6.92639C6.90263 6.8966 7.23029 6.66142 7.3752 6.31722L9.40401 1.49833Z"
          stroke="currentColor"
          stroke-width="0.75"
        />
      </svg>
    </template>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    stars: number;
  }>();
</script>

<style scoped></style>
